class Helpers {
    static formatTime(input) {
        //noinspection EqualityComparisonWithCoercionJS
        if (input.trim().length == 0) {
            return '';
        }

        let hour = 0, minute = 0;

        if (input.indexOf(':') < 0) {
            if (!isNaN(input) && isFinite(input)) {
                if (input.length > 2) {
                    return this.formatTime(input.substr(0, input.length - 2) + ':' + input.substr(-2));
                } else {
                    //noinspection EqualityComparisonWithCoercionJS
                    if (input < 0 || input == 24) {
                        hour = 0;
                    } else if (input > 23) {
                        hour = 23;
                    } else {
                        hour = parseInt(input, 10);
                    }
                }
            }
        } else {
            const split = input.split(':');

            if (split[0].length > 0 && !isNaN(split[0]) && isFinite(split[0])) {
                //noinspection EqualityComparisonWithCoercionJS
                if (split[0] < 0 || split[0] == 24) {
                    hour = 0;
                } else if (split[0] > 23) {
                    hour = 23;
                } else {
                    hour = parseInt(split[0], 10);
                }
            }

            if (split[1].length > 0 && !isNaN(split[1]) && isFinite(split[1])) {
                //noinspection EqualityComparisonWithCoercionJS
                if (split[1] < 0 || split[1] == 60) {
                    minute = 0;
                } else if (split[1] > 59) {
                    minute = 59;
                } else {
                    minute = parseInt(split[1], 10);
                }
            }
        }

        return (hour < 10 ? '0' : '') + hour + ':' + (minute < 10 ? '0' : '') + minute;
    }

    static formatTimeInput(element) {
        if (!(element instanceof jQuery)) {
            element = jQuery(element);
        }

        element.val(this.formatTime(element.val()));
    }

    static validateFilename(filename) {
        const INVALID_CHARS = ['*', '"', '/', '\\', '[', ']', '<', '>', ':', ';', '|', '=', '?', '\'', '+', '&'];

        for (let i = 0, j = INVALID_CHARS.length; i < j; i++) {
            if (filename.indexOf(INVALID_CHARS[i]) < 0) {
                continue;
            }

            return false;
        }

        return true;
    }

    static validateFilenameInput(element) {
        if (!(element instanceof jQuery)) {
            element = jQuery(element);
        }

        return this.validateFilename(element.val());
    }
}